import styled from 'styled-components';

//.info-video-wrapper + info-movie
export const TrailerDefaultBox = styled.div`
    width: 100%;
    height: 100%;
    margin-bottom: 1.1rem;
`;